<button
    *ngIf="showMinus"
    (click)="onButtonClicked($event, 'minus')"
    class="minus btn btn-link"
    type="button"
    title="Delete row"
></button>
<button
    *ngIf="showPlus"
    (click)="onButtonClicked($event, 'plus')"
    class="btn btn-link plus"
    type="button"
    title="Add row"
></button>